
const digest = '48f760a4ffd51430fb15a410a8288423bf5201ba2eff3535614124747550cb3a';
const css = `._embedInline_1gdfa_1 {
  display: inline-block;
  vertical-align: middle;
  margin: 0.5em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"embedInline":"_embedInline_1gdfa_1"};
export { css, digest };
  